'use strict';

const { checkOverflow } = require('./blogTile');

/**
 * Updates the "last-visible" class on blog tiles within a layout.
 * Ensures the final visible blog tile has the `.last-visible` class applied.
 *
 * @param {$} $layout - The jQuery-wrapped container element containing blog tiles.
 */
function updateLastVisibleTile($layout) {
    var $cards = $layout.find('.blog-tiles-wrapper .blog-tile-component:visible');
    $cards.removeClass('last-visible');
    $cards.last().addClass('last-visible');
}

/**
 * Updates the blog count text displayed in the `.blogs-count` element.
 * Shows the number of currently visible blogs versus the total count.
 *
 * @param {$} $layout - The jQuery-wrapped container element containing blog tiles.
 */
function updateBlogCount($layout) {
    var $cards = $layout.find('.blog-tiles-wrapper .blog-tile-component');
    var visibleCount = $cards.filter(':visible').length;
    var totalCount = $cards.length;

    $('.blogs-count').text(visibleCount + ' of ' + totalCount + ' Blogs');
}

/**
 * Initializes and displays the initial set of blog tiles within each blog layout.
 * Handles:
 * - Showing only the initial batch of tiles.
 * - Updating blog count and last visible tile.
 * - Showing or hiding the "Load More" button as needed.
 */
function displayBlogTiles() {
    $('.blogs-container .blog-tiles').each(function () {
        var $layout = $(this);
        var initialCount = parseInt($layout.data('initial-count'), 10) || 0;
        var $cards = $layout.find('.blog-tiles-wrapper .blog-tile-component');
        var $loadMoreBtn = $layout.find('.load-more-btn');

        // Hide all and show only the initialCount cards
        $cards.hide().slice(0, initialCount).show();

        // Update layout states
        updateLastVisibleTile($layout);
        updateBlogCount($layout);

        // Show or hide "Load More" button based on total card count
        if ($cards.length > initialCount) {
            $loadMoreBtn.removeClass('d-none').show();
        } else {
            $loadMoreBtn.addClass('d-none').hide();
        }
    });
}

$(document).ready(function () {
    // Initialize blog tiles display
    displayBlogTiles();

    $(document).on('click', '.load-more-btn', function () {
        var $btn = $(this);
        var $layout = $('.blogs-container .blog-tiles');
        var loadCount = parseInt($layout.attr('data-load-count'), 10) || 0;

        var $cards = $layout.find('.blog-tiles-wrapper .blog-tile-component');
        var visibleCount = $cards.filter(':visible').length;

        // Show the next batch of hidden cards
        $cards.slice(visibleCount, visibleCount + loadCount).show();

        // Function to check the overflown content in the blog tile.
        checkOverflow();
        // Update layout states
        updateLastVisibleTile($layout);
        updateBlogCount($layout);

        // Hide "Load More" button if all cards are now visible
        if ($cards.filter(':visible').length >= $cards.length) {
            $btn.addClass('d-none').hide();
        }
    });

    $(document).on('click', '.blog-share-icon', function () {
        var blogUrl = $(this).data('blog-url');
        var blogTitle = $(this).data('blog-title');

        var encodedUrl = encodeURIComponent(blogUrl);
        var encodedTitle = encodeURIComponent(blogTitle);

        // Update social media share links
        $('#share-whatsapp').attr('href', 'https://api.whatsapp.com/send?text=' + encodedTitle + '%20' + encodedUrl);
        $('#share-gmail').attr('href', 'mailto:email@example.com?subject=' + encodedTitle + '&body=' + encodedUrl);
        $('#share-instagram').attr('href', 'https://www.instagram.com/?url=' + encodedUrl + '&text=' + encodedTitle);
        $('#share-facebook').attr('href', 'https://www.facebook.com/share.php?u=' + encodedUrl + '&text=' + encodedTitle);
        $('#share-twitter').attr('href', 'https://x.com/intent/post?url=' + encodedUrl + '&text=' + encodedTitle);

        // Update the input placeholder with the blog URL
        $('.main-url-form .url-copy-label').attr('placeholder', blogUrl);

        // Show the share modal
        $('#blogShareModal').modal('show');
    });

    $('#blogShareModal .url-copy-btn').on('click', function () {
        var $input = $(this).closest('.main-url-form').find('.url-copy-label');
        var copyValue = $input.val() || $input.attr('placeholder') || '';

        if (copyValue) {
            navigator.clipboard.writeText(copyValue);
        }

        // Remove focus from the button after copying
        $(this).blur();
    });
});
